const B100 = "#66a6ff";
const B200 = "#3388ff";
const B25 = "#f5f9ff";
const B300 = "#1a79ff";
const B400 = "#136dec";
const B50 = "#cce1ff";
const B500 = "#1458b8";
const B75 = "#99c4ff";
const G100 = "#7de8a1";
const G200 = "#61d187";
const G300 = "#2fba5e";
const G400 = "#008542";
const G50 = "#dffbe9";
const G500 = "#006633";
const G75 = "#a3f5bf";
const N0 = "#ffffff";
const N0a = "#ffffff";
const N10 = "#f9fafa";
const N100 = "#7c8a9c";
const N20 = "#f3f4f6";
const N200 = "#6c7889";
const N20a = "#030a16";
const N25a = "#030b16";
const N30 = "#ebedf0";
const N300 = "#627084";
const N30a = "#030b16";
const N40 = "#e3e5e8";
const N400 = "#52637a";
const N50 = "#c4cbd4";
const N500 = "#394960";
const N60 = "#b7bec8";
const N600 = "#2d3d53";
const N70 = "#a9b1bc";
const N700 = "#1f3047";
const N80 = "#9aa4b1";
const N800 = "#132339";
const N800a = "#132339";
const N90 = "#8c97a6";
const N900 = "#030b16";
const P100 = "#954dc9";
const P200 = "#8633c1";
const P25 = "#f0e6f7";
const P300 = "#6800b2";
const P400 = "#570f8a";
const P50 = "#d9bfec";
const P500 = "#390f57";
const P75 = "#b480d9";
const R100 = "#fe8b72";
const R200 = "#fd6e4e";
const R300 = "#fd4e2b";
const R400 = "#e6360f";
const R50 = "#ffeae6";
const R500 = "#c02502";
const R75 = "#feb5a4";
const Y100 = "#ffe680";
const Y200 = "#ffd11a";
const Y300 = "#ffbf1a";
const Y400 = "#ffaa33";
const Y50 = "#fffae5";
const Y500 = "#ff9500";
const Y75 = "#fff0b3";
const bgOverlay = "#132339";
const bgPrimary = "#ffffff";
const bgSecondary = "#f3f4f6";
const borderFocus = "#66a6ff";
const borderMenuContainer = "#ebedf0";
const borderTextField = "#c4cbd4";
const borderTextFieldError = "#e6360f";
const borderToggle = "#c4cbd4";
const buttonPrimaryEnabled = "#136dec";
const buttonPrimaryHover = "#1a79ff";
const buttonPrimaryPressed = "#1458b8";
const buttonSecondaryEnabled = "#030a160a";
const buttonSecondaryHover = "#030b1614";
const buttonSecondaryPressed = "#394960";
const buttonSecondarySelected = "#2d3d53";
const buttonTertiaryHover = "#030b1614";
const buttonTertiaryPressed = "#394960";
const buttonTertiarySelected = "#2d3d53";
const buttonDisabled = "#030a160a";
const cellDefault = "#ffffff";
const cellHover = "#030a16";
const cellPressed = "#030b16";
const cellSelected = "#030b16";
const cellTableHover = "#f5f9ff";
const cellTableSelected = "#cce1ff";
const dividerBold = "#e3e5e8";
const dividerRegular = "#ebedf0";
const iconDisabled = "#b7bec8";
const iconError = "#e6360f";
const iconOnColor = "#ffffff";
const iconPrimary = "#132339";
const iconSecondary = "#52637a";
const iconSuccess = "#2fba5e";
const iconTertiary = "#a9b1bc";
const linkDisabled = "#b7bec8";
const linkHover = "#1a79ff";
const linkPrimary = "#136dec";
const linkSecondary = "#52637a";
const linkVisited = "#570f8a";
const navPrimary = "#ffffff";
const navSecondary = "#f3f4f6";
const messageBgConfirm = "#dffbe9";
const messageBgError = "#ffeae6";
const messageBgInfo = "#f0e6f7";
const messageBgWarning = "#fffae5";
const messageIconConfirm = "#008542";
const messageIconError = "#e6360f";
const messageIconInfo = "#570f8a";
const messageIconWarning = "#ffaa33";
const snackbarDefault = "#ffffff";
const spinerForeground = "#2d3d53";
const spinerPrimaryOnColor = "#ffffff";
const spinerSecondary = "#132339";
const spinerSecondaryOnColor = "#ffffff";
const statusBgError = "#ffeae6";
const statusBgInfo = "#cce1ff";
const statusBgNeutral = "#030a160a";
const statusBgNew = "#f0e6f7";
const statusBgSuccess = "#dffbe9";
const statusWarning = "#fffae5";
const statusTextError = "#c02502";
const statusTextInfo = "#1458b8";
const statusTextNeutral = "#52637a";
const statusTextNew = "#390f57";
const statusTextSuccess = "#006633";
const statusTextWarning = "#2d3d53";
const tabEnabled = "#52637a";
const tabHover = "#1a79ff";
const tabPressed = "#1458b8";
const tabSelected = "#136dec";
const tagBg = "#030b16";
const tagButtonOnHover = "#feb5a4";
const textBreadcrumbs = "#7c8a9c";
const textDisable = "#b7bec8";
const textError = "#e6360f";
const textOnColor = "#ffffff";
const textPlaceholder = "#6c7889";
const textPrimary = "#132339";
const textSecondary = "#52637a";
const textTertiary = "#627084";
const textFieldDisabled = "#f3f4f6";
const textFieldFocus = "#ffffff";
const textFieldHover = "#ebedf0";
const textFieldInactive = "#f9fafa";
const toggleCheckedEnable = "#136dec";
const toggleCheckedHover = "#1a79ff";
const toggleCheckedPressed = "#1458b8";
const toggleDisabled = "#f3f4f6";
const toggleHover = "#ebedf0";
const toggleInactive = "#f9fafa";
const togglePressed = "#030b16";
const tooltipBg = "#132339";
const tooltipText = "#ffffff";
const calPeriodSelected = "#132339";
const calPeriodHover = "#2D3D53";
const calPeriodPressed = "#394960";
const calInPeriod = "#030a160a";
const calToday = "#136DEC";
const segmentSelected = "#FFFFFF";
const bgSegmentedControls = "#F3F4F6";
export default {
    B100,
    B200,
    B25,
    B300,
    B400,
    B50,
    B500,
    B75,
    G100,
    G200,
    G300,
    G400,
    G50,
    G500,
    G75,
    N0,
    N0a,
    N10,
    N100,
    N20,
    N200,
    N20a,
    N25a,
    N30,
    N300,
    N30a,
    N40,
    N400,
    N50,
    N500,
    N60,
    N600,
    N70,
    N700,
    N80,
    N800,
    N800a,
    N90,
    N900,
    P100,
    P200,
    P25,
    P300,
    P400,
    P50,
    P500,
    P75,
    R100,
    R200,
    R300,
    R400,
    R50,
    R500,
    R75,
    Y100,
    Y200,
    Y300,
    Y400,
    Y50,
    Y500,
    Y75,
    bgOverlay,
    bgPrimary,
    bgSecondary,
    borderFocus,
    borderMenuContainer,
    borderTextField,
    borderTextFieldError,
    borderToggle,
    buttonPrimaryEnabled,
    buttonPrimaryHover,
    buttonPrimaryPressed,
    buttonSecondaryEnabled,
    buttonSecondaryHover,
    buttonSecondaryPressed,
    buttonSecondarySelected,
    buttonTertiaryHover,
    buttonTertiaryPressed,
    buttonTertiarySelected,
    buttonDisabled,
    cellDefault,
    cellHover,
    cellPressed,
    cellSelected,
    cellTableHover,
    cellTableSelected,
    dividerBold,
    dividerRegular,
    iconDisabled,
    iconError,
    iconOnColor,
    iconPrimary,
    iconSecondary,
    iconSuccess,
    iconTertiary,
    linkDisabled,
    linkHover,
    linkPrimary,
    linkSecondary,
    linkVisited,
    navPrimary,
    navSecondary,
    messageBgConfirm,
    messageBgError,
    messageBgInfo,
    messageBgWarning,
    messageIconConfirm,
    messageIconError,
    messageIconInfo,
    messageIconWarning,
    snackbarDefault,
    spinerForeground,
    spinerPrimaryOnColor,
    spinerSecondary,
    spinerSecondaryOnColor,
    statusBgError,
    statusBgInfo,
    statusBgNeutral,
    statusBgNew,
    statusBgSuccess,
    statusWarning,
    statusTextError,
    statusTextInfo,
    statusTextNeutral,
    statusTextNew,
    statusTextSuccess,
    statusTextWarning,
    tabEnabled,
    tabHover,
    tabPressed,
    tabSelected,
    tagBg,
    tagButtonOnHover,
    textBreadcrumbs,
    textDisable,
    textError,
    textOnColor,
    textPlaceholder,
    textPrimary,
    textSecondary,
    textTertiary,
    textFieldDisabled,
    textFieldFocus,
    textFieldHover,
    textFieldInactive,
    toggleCheckedEnable,
    toggleCheckedHover,
    toggleCheckedPressed,
    toggleDisabled,
    toggleHover,
    toggleInactive,
    togglePressed,
    tooltipBg,
    tooltipText,
    calPeriodSelected,
    calPeriodPressed,
    calInPeriod,
    calToday,
    calPeriodHover,
    segmentSelected,
    bgSegmentedControls,
};
//# sourceMappingURL=colors.js.map